import { NavigationActions } from "react-navigation";

import { store } from "state";
import { isStandardApp } from "state/modules/survey/selectors";

let _navigator;
export const _setNavigator = ref => (_navigator = ref);

const jumpTo = routeName => {
  const state = store.getState();

  isStandardApp(state) &&
    _navigator?.dispatch(NavigationActions.navigate({ routeName }));
};

export const Navigator = { jumpTo };
